import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-end gap-4" }
const _hoisted_5 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex align-items-center gap-2" }

import { ref, onMounted } from "vue";
import PaymentService from "../services/PaymentService";
import CreateRefund from "../components/modal/CreateRefund.vue";
import { useI18n } from "vue-i18n";
import { Document } from "@element-plus/icons-vue";
import HistoryRecord from "../components/modal/HistoryRecord.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RefundIndex',
  setup(__props) {

const historyRef = ref<any>(null);
const t = useI18n().t;
const isLoading = ref(false);
const data = ref<any>([]);
const createRefundRef = ref<InstanceType<typeof CreateRefund>>();

const criteria = ref<any>({
  page: 1,
  size: 20,
  targetId: null,
  targetType: 1,
});
const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    const res = await PaymentService.queryRefunds(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const showCreateRefund = () => {
  createRefundRef.value?.show();
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
    targetType: 1,
    targetId: null,
  };
  fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: criteria.value.targetId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.targetId) = $event)),
                placeholder: _unref(t)('fields.walletId')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: criteria.value.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.email) = $event)),
                class: "w-250px ms-2",
                placeholder: _ctx.$t('fields.email'),
                clearable: ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, { onClick: reset }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (_ctx.$can('TenantAdmin') || _ctx.$can('SuperAdmin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCreateRefund()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.createRefund")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.walletId")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.comment")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_13, [
                        (item.user)
                          ? (_openBlock(), _createBlock(_component_UserInfo, {
                              key: 0,
                              user: item.user,
                              class: "me-2"
                            }, null, 8, ["user"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, _toDisplayString(item.targetId), 1),
                          _createVNode(_component_el_button, {
                            icon: _unref(Document),
                            circle: "",
                            onClick: ($event: any) => (historyRef.value.show(item.id))
                          }, null, 8, ["icon", "onClick"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_BalanceShow, {
                          "currency-id": item.currencyId,
                          balance: item.amount
                        }, null, 8, ["currency-id", "balance"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.comment), 1)
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(CreateRefund, {
      ref_key: "createRefundRef",
      ref: createRefundRef,
      onEventSubmit: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(HistoryRecord, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ], 64))
}
}

})